export default __webpack_public_path__ + "static/media/beauty_back.99be4d7f.jpg";